"use client";

import type * as React from "react";

import { cn } from "../cn";

function Label({ className, ...props }: React.ComponentProps<"label">) {
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: generic wrapper; callers pass htmlFor or nest the control.
    <label
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-xs leading-4 font-ui text-secondary select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-55 peer-disabled:cursor-not-allowed peer-disabled:opacity-55",
        className,
      )}
      {...props}
    />
  );
}

export { Label };
